import create from 'zustand';
import produce from 'immer';

const PARENT_PAYMENT_INITIAL = {
	children: [],
	current: []
};

export const useParentPaymentStore = create(set => ({
	...PARENT_PAYMENT_INITIAL,

	// Initialize student's payment state
	onInit: (children) => set(produce(state => {
		state.children = children?.map(child => {
			const grade = child?.grades?.find(g => g.state === 'active');
			const payments = child?.payments?.filter(p => p.gradeId === grade.id);
			const current = payments?.find(p => p.state === 'scheduled');

			// Add current payment for children
			if (current) state.current.push(current);

			return {
				id: child.id,
				avatar: child.avatar,
				fullName: child.fullName,
				payments: payments
			};
		});
	})),

	// Reset store to initial state
	onReset: () => set({
		...PARENT_PAYMENT_INITIAL
	})
}));